// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---fZI5g","changedRecordsList":"changedRecordsList---vq_jO","changedRecord":"changedRecord---lp8o1"};